import { Roles } from "../Constants/UserTypes";
export { Roles } from "../Constants/UserTypes";

export function isInternalDeveloper(user) {
    return user != null && user.roles != null && user.roles.includes(Roles.APP_ADMIN_INTERNAL);
}

export function isDeveloper(user) {
    return user != null && user.roles != null && user.roles.includes(Roles.APP_ADMIN);
}

export function isSuperAdmin(user) {
    return user !== null && user.roles != null && user.roles.includes(Roles.SUPERADMIN);
}

export function isAppSuperAdmin(user) {
    return user != null && user.roles != null && user.roles.includes(Roles.APP_SUPERADMIN);
}

export function isCompanyAdmin(user) {
    return user != null && user.roles != null && user.roles.includes(Roles.COMPANY_ADMIN);
}

export function isAppSupport(user) {
    return user != null && user.roles != null && user.roles.includes(Roles.APP_SUPPORT);
}

export function isSupport(user) {
    if (!user || !user.roles) {
        return false;
    }
    const filteredRoles = user.roles.filter(value => value !== Roles.APP_SUPPORT);
    if (filteredRoles.includes(Roles.SUPPORT)) {
        return true;
    }

    return false;
}

export function isDeveloperOrInternalDeveloper(user) {
    return isDeveloper(user) || isInternalDeveloper(user);
}

export function isSuperAdminOrAppSuperAdmin(user) {
    return isSuperAdmin(user) || isAppSuperAdmin(user);
}

export function isSupportOrAppSupport(user) {
    return isSupport(user) || isAppSupport(user);
}

export function isOnlySupportOrAppSupport(user) {
    return isSupportOrAppSupport(user) && !isSuperAdminOrAppSuperAdmin(user) && !isDeveloperOrInternalDeveloper(user);
}

export const getDevelopers = (contactList) => {
    let developerList = [];
    contactList.forEach(contact => {
        const foundIndex = developerList.findIndex(item => item.id === contact.id);
        if (foundIndex < 0 && (isDeveloper(contact) || contact?.developer?.account === "confirmed")) {
            developerList.push(contact);
        }
    });

    return developerList;
}

export const getInternalDevelopers = (contactList) => {
    let developerList = [];
    contactList.forEach(contact => {
        const foundIndex = developerList.findIndex(item => item.id === contact.id);
        if (foundIndex < 0 && isInternalDeveloper(contact)) {
            developerList.push(contact);
        }
    });

    return developerList;
}

export const isUserFullyLoaded = (contact) => {
    if (contact && Object.keys(contact).length > 1)
        return true;
    return false;
}
